<template>
  <div>
    <div class="form-group">
      <div class="form-row align-items-end">
        <div class="col">
          <label :for="safeId('inputTimeHours')" class="col-form-label">Hours</label>
          <input type="number" :id="safeId('inputTimeHours')" class="form-control" v-model="timeHours" min="0" max="99"
                 :disabled="isRunning">
        </div>
        <div class="col">
          <label :for="safeId('inputTimeMins')" class="col-form-label">Mins</label>
          <input type="number" :id="safeId('inputTimeMins')" class="form-control" v-model="timeMins" min="0" max="59"
                 :disabled="isRunning">
        </div>
        <div class="col">
          <label :for="safeId('inputTimeSecs')" class="col-form-label">Secs</label>
          <input type="number" :id="safeId('inputTimeSecs')" class="form-control" v-model="timeSecs" min="0" max="59"
                 :disabled="isRunning">
        </div>
        <div class="col">
          <label :for="safeId('inputTimeMillis')" class="col-form-label">Ms</label>
          <input type="number" :id="safeId('inputTimeMillis')" class="form-control" v-model="timeMillis" min="0"
                 max="999" :disabled="isRunning">
        </div>
        <div class="col">
          <button class="btn btn-block btn-primary" @click="toggle()">
            <icon name="play" v-if="!isRunning"></icon>
            <icon name="pause" v-if="isRunning"></icon>
          </button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-warning" @click="reset()">
            <icon name="repeat"></icon>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-row align-items-end">
        <div class="col">
          <button class="btn btn-block btn-secondary" @click="shift(+1000 * 60)">+1'</button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-secondary" @click="shift(-1000 * 60)">-1'</button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-secondary" @click="shift(+1000)">+1"</button>
        </div>
        <div class="col">
          <button class="btn btn-block btn-secondary" @click="shift(-1000)">-1"</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapOverlayData, mapTemplateOptions } from '../../utils/index'
  import * as action from '../../store/action-types'

  export default {
    name: 'clock-control',
    props: ['templateId'],
    data () {
      return {
        localCurrentTimeMs: 0,
        localCurrentTimeUtc: 0,
        timeHours: 0,
        timeMins: 0,
        timeSecs: 0,
        timeMillis: 0
      }
    },
    computed: {
      ...mapOverlayData({
        'direction': {default: 'up'},
        'isRunning': {default: false},
        'currentTimeMs': {default: 0}
      }),
      ...mapTemplateOptions({
        'startTimeMs': {default: 0},
        'endTimeMs': {default: 0}
      })
    },
    mounted () {
      this.updateTime()
    },
    beforeDestroy () {
      this.clearTimeout()
    },
    watch: {
      isRunning: function () {
        this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs
        this.updateTime()
      },
      currentTimeMs: function () {
        this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs
        this.updateTime()
      },
      localCurrentTimeMs: function (val) {
        const time = new Date(val)
        this.timeHours = time.getUTCHours()
        this.timeMins = time.getMinutes()
        this.timeSecs = time.getSeconds()
        this.timeMillis = time.getMilliseconds()
      }
    },
    methods: {
      toggle () {
        if (!this.isRunning) {
          this.start()
        } else {
          this.stop()
        }
      },
      start () {
        const currentTimeMs = this.timeHours * 3600 * 1000 +
          this.timeMins * 60 * 1000 +
          this.timeSecs * 1000 + this.timeMillis
        this.updateData({
          direction: this.direction,
          isRunning: true,
          currentTimeMs: currentTimeMs,
          currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
        })
      },
      stop (currentTimeMs) {
        if (currentTimeMs === undefined) {
          if (this.direction === 'down') {
            currentTimeMs = this.localCurrentTimeUtc - Date.now()
          } else {
            currentTimeMs = Date.now() - this.localCurrentTimeUtc
          }
          if (currentTimeMs <= 0) {
            currentTimeMs = 0
            this.localCurrentTimeUtc = Date.now()
          }
        }
        this.updateData({
          direction: this.direction,
          isRunning: false,
          currentTimeMs: currentTimeMs,
          currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
        })
      },
      reset () {
        const currentTimeMs = this.startTimeMs
        this.updateData({
          direction: this.direction,
          isRunning: false,
          currentTimeMs: currentTimeMs,
          currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
        })
      },
      shift (milliseconds) {
        this.clearTimeout()
        let currentTimeMs = 0
        if (this.isRunning) {
          if (this.direction === 'down') {
            currentTimeMs = this.localCurrentTimeUtc - Date.now() + milliseconds
          } else {
            currentTimeMs = Date.now() - this.localCurrentTimeUtc + milliseconds
          }
        } else {
          currentTimeMs = this.currentTimeMs + milliseconds
        }
        if (currentTimeMs < 0) currentTimeMs = 0
        this.updateData({
          direction: this.direction,
          isRunning: this.isRunning,
          currentTimeMs: currentTimeMs,
          currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
        })
      },
      updateTime () {
        this.clearTimeout()
        if (this.isRunning) {
          let newCurrentTimeMs
          let timeoutDelay
          if (this.direction === 'down') {
            newCurrentTimeMs = this.localCurrentTimeUtc - Date.now()
            timeoutDelay = new Date(newCurrentTimeMs).getMilliseconds()

            if (newCurrentTimeMs < this.endTimeMs) {
              newCurrentTimeMs = this.endTimeMs
              this.localCurrentTimeMs = newCurrentTimeMs
              this.stop(newCurrentTimeMs)
            }
          } else {
            newCurrentTimeMs = Date.now() - this.localCurrentTimeUtc
            timeoutDelay = 1000 - new Date(newCurrentTimeMs).getMilliseconds()

            if (this.endTimeMs > 0 && newCurrentTimeMs >= this.endTimeMs) {
              newCurrentTimeMs = this.endTimeMs
              this.localCurrentTimeMs = newCurrentTimeMs
              this.stop(newCurrentTimeMs)
            }
          }

          this.localCurrentTimeMs = newCurrentTimeMs
          this.timeoutId = window.setTimeout(this.updateTime, timeoutDelay)
        } else {
          this.localCurrentTimeMs = this.currentTimeMs
        }
      },
      updateData (data) {
        data.startTimeMs = this.startTimeMs
        data.endTimeMs = this.endTimeMs
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data
        })
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data
        })
      },
      clearTimeout () {
        if (this.timeoutId) {
          window.clearTimeout(this.timeoutId)
          this.timeoutId = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/clock-control.vue